import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import Layout from './components/layout/Layout'
import { LegacyAuthProvider } from './contexts/AuthContext'
import SignIn from './pages/auth/SignIn'
import SignUp from './pages/auth/SignUp'
import Dashboard from './pages/dashboard/Dashboard'
import FinanceOverview from './pages/finance/FinanceOverview'
import FinanceCashFlow from './pages/finance/FinanceCashFlow'
import FinanceInvoices from './pages/finance/FinanceInvoices'
import FinancePurchases from './pages/finance/FinancePurchases'
import FinanceProductsServices from './pages/finance/FinanceProductsServices'
import FinanceOperationalCosts from './pages/finance/FinanceOperationalCosts'
import FinanceSnapshot from './pages/finance/FinanceSnapshot'
import FinanceAnalytics from './pages/finance/FinanceAnalytics'
import Reports from './pages/reports/Reports'
import Settings from './pages/settings/Settings'
import ClearingStatus from './pages/clearing/ClearingStatus'
import ContractFile from './pages/contracts/ContractFile'
import StorageInventory from './pages/storage/StorageInventory'
import Shipments from './pages/shipments/Shipments'
import OrderFulfillment from './pages/order-fulfillment/OrderFulfillment'
import StockDispatch from './pages/load-out/StockDispatch'
import { ROUTES } from './constants/routes'
import { isOktaConfigured, getOktaAuth } from './config/okta'
import OktaSecurityWrapper, { LoginCallback } from './components/auth/OktaSecurityWrapper'
import SignInOkta from './pages/auth/SignInOkta'
import RequireAuth from './components/auth/RequireAuth'
import LegacyRequireAuth from './components/auth/LegacyRequireAuth'

const LoadOutPage = () => <StockDispatch />
import Notifications from './pages/notifications/Notifications'
import AIActionsPage from './pages/ai-actions/AIActionsPage'

/** Fragment of Route elements – must be JSX, not a component, so React Router accepts it. */
const ProtectedRoutesContent = (
  <>
    <Route index element={<Navigate to={ROUTES.DASHBOARD} replace />} />
    <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
        
        {/* Shipments */}
        <Route path={ROUTES.SHIPMENTS} element={<Shipments />} />
        <Route path={ROUTES.SHIPMENTS_NEW} element={<Shipments />} />
        <Route path={ROUTES.SHIPMENTS_EDIT} element={<Shipments />} />
        <Route path={ROUTES.SHIPMENTS_DETAIL} element={<Shipments />} />
        
        {/* Order Fulfillment */}
        <Route path={ROUTES.ORDER_FULFILLMENT} element={<OrderFulfillment />} />
        <Route path={ROUTES.ORDER_FULFILLMENT_NEW} element={<OrderFulfillment />} />
        <Route path={ROUTES.ORDER_FULFILLMENT_DETAIL} element={<OrderFulfillment />} />
        
        {/* Inventory */}
        <Route path={ROUTES.INVENTORY} element={<StorageInventory />} />
        <Route path={ROUTES.INVENTORY_NEW} element={<StorageInventory />} />
        <Route path={ROUTES.INVENTORY_EDIT} element={<StorageInventory />} />
        <Route path={ROUTES.INVENTORY_DETAIL} element={<StorageInventory />} />
        
        {/* Contracts */}
        <Route path={ROUTES.CONTRACTS} element={<ContractFile />} />
        <Route path={ROUTES.CONTRACTS_SALE} element={<ContractFile />} />
        <Route path={ROUTES.CONTRACTS_BUY} element={<ContractFile />} />
        <Route path={ROUTES.CONTRACTS_PERFORMANCE} element={<ContractFile />} />
        <Route path={ROUTES.CONTRACTS_NEW} element={<ContractFile />} />
        <Route path={ROUTES.CONTRACTS_DETAIL} element={<ContractFile />} />
        
        {/* Clearing */}
        <Route path={ROUTES.CLEARING} element={<ClearingStatus />} />
        <Route path={ROUTES.CLEARING_DETAIL} element={<ClearingStatus />} />
        
        {/* Storage (placeholder routes hidden) */}
        <Route path={ROUTES.STORAGE} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.STORAGE_WAREHOUSES} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.STORAGE_MOVEMENTS} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        
        {/* Load Out */}
        <Route path={ROUTES.LOAD_OUT} element={<LoadOutPage />} />
        <Route path={ROUTES.LOAD_OUT_NEW} element={<LoadOutPage />} />
        <Route path={ROUTES.LOAD_OUT_DETAIL} element={<LoadOutPage />} />
        
        {/* Vendors (placeholder routes hidden) */}
        <Route path={ROUTES.VENDORS} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.VENDORS_NEW} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.VENDORS_EDIT} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.VENDORS_DETAIL} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        
        {/* Payments (placeholder routes hidden) */}
        <Route path={ROUTES.PAYMENTS} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.PAYMENTS_NEW} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.PAYMENTS_DETAIL} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        
        {/* Finance */}
        <Route path={ROUTES.FINANCE_OVERVIEW} element={<FinanceOverview />} />
        <Route path={ROUTES.FINANCE_CASH_FLOW} element={<FinanceCashFlow />} />
        <Route path={ROUTES.FINANCE_INVOICES} element={<FinanceInvoices />} />
        <Route path={ROUTES.FINANCE_PURCHASES} element={<FinancePurchases />} />
        <Route path={ROUTES.FINANCE_PRODUCTS_SERVICES} element={<FinanceProductsServices />} />
        <Route path={ROUTES.FINANCE_OPERATIONAL_COSTS} element={<FinanceOperationalCosts />} />
        <Route path={ROUTES.FINANCE_SNAPSHOT} element={<FinanceSnapshot />} />
        <Route path={ROUTES.FINANCE_ANALYTICS} element={<FinanceAnalytics />} />
        
        {/* Reports */}
        <Route path={ROUTES.REPORTS} element={<Reports />} />
        <Route path={ROUTES.REPORTS_SHIPMENTS} element={<Reports />} />
        <Route path={ROUTES.REPORTS_INVENTORY} element={<Reports />} />
        <Route path={ROUTES.REPORTS_PAYMENTS} element={<Reports />} />
        
        {/* Documents (placeholder route hidden) */}
        <Route path={ROUTES.DOCUMENTS} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        
        {/* Users (placeholder routes hidden) */}
        <Route path={ROUTES.USERS} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.USERS_NEW} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path={ROUTES.USERS_EDIT} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        
        {/* Notifications */}
        <Route path={ROUTES.NOTIFICATIONS} element={<Notifications />} />
        {/* Phase 3: AI Actions */}
        <Route path={ROUTES.AI_ACTIONS} element={<AIActionsPage />} />
        
        {/* Settings */}
        <Route path={ROUTES.SETTINGS} element={<Settings />} />
        <Route path={ROUTES.SETTINGS_GENERAL} element={<Settings />} />
        <Route path={ROUTES.SETTINGS_INTEGRATIONS} element={<Settings />} />
        <Route path={ROUTES.SETTINGS_NOTIFICATIONS} element={<Settings />} />
    <Route path={ROUTES.SETTINGS_USER_MANAGEMENT} element={<Settings />} />
  </>
)

// Resolve Okta once at module level so we don't recreate on every render
const oktaEnabled = isOktaConfigured()
const oktaAuth = oktaEnabled ? getOktaAuth() : null

/**
 * When Okta is configured the app uses OktaSecurityWrapper which provides:
 *   - Okta Security context
 *   - OktaAuthProvider (logout via oktaAuth.signOut())
 *   - OktaTokenSync (pushes Okta access token into localStorage for API client)
 *   - RequireAuth on protected routes (redirects to Okta sign-in if unauthenticated)
 *
 * When Okta is NOT configured the app falls back to the legacy email/password flow
 * with LegacyAuthProvider (identical to previous behaviour).
 */
function App() {
  // ---------- Okta mode ----------
  if (oktaEnabled && oktaAuth) {
    return (
      <Router>
        <OktaSecurityWrapper oktaAuth={oktaAuth}>
          <Routes>
            {/* Okta login callback – must be OUTSIDE RequireAuth */}
            <Route path={ROUTES.LOGIN_CALLBACK} element={<LoginCallback />} />

            {/* Okta sign-in page (single button → redirect to Okta hosted sign-in) */}
            <Route path={ROUTES.LOGIN} element={<SignInOkta />} />
            <Route path={ROUTES.SIGNUP} element={<SignUp />} />

            {/* All protected routes wrapped by RequireAuth */}
            <Route element={<RequireAuth />}>
              <Route path="/" element={<Layout><Outlet /></Layout>}>
                {ProtectedRoutesContent}
              </Route>
            </Route>

            <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
          </Routes>
        </OktaSecurityWrapper>
      </Router>
    )
  }

  // ---------- Legacy email/password mode ----------
  return (
    <Router>
      <LegacyAuthProvider>
        <Routes>
          <Route path={ROUTES.LOGIN} element={<SignIn />} />
          <Route path={ROUTES.SIGNUP} element={<SignUp />} />
          <Route element={<LegacyRequireAuth />}>
            <Route path="/" element={<Layout><Outlet /></Layout>}>
              {ProtectedRoutesContent}
            </Route>
          </Route>
          <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        </Routes>
      </LegacyAuthProvider>
    </Router>
  )
}

export default App
